const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://conexapi.fundacionnigma.org';

export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };

  // Asegurar que endpoint tenga /api al inicio
  const cleanEndpoint = endpoint.startsWith('/api') ? endpoint : `/api${endpoint}`;
  // Asegurar que no haya doble barra
  const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  const endpointUrl = cleanEndpoint.startsWith('/') ? cleanEndpoint : `/${cleanEndpoint}`;

  // Add cache-busting for users endpoint only on GET requests
  // Usar & si ya hay query params, sino usar ?
  const isGet = (config.method || 'GET').toUpperCase() === 'GET';
  let url = `${baseUrl}${endpointUrl}`;
  if (isGet && endpoint.includes('/users')) {
    const separator = url.includes('?') ? '&' : '?';
    url += `${separator}t=${Date.now()}`;
  }

  const response = await fetch(url, config);

  // Manejar 401 Y 403 (token expirado o inválido)
  if (response.status === 401 || response.status === 403) {
    // Si el token expiró o es inválido, redirigir al login
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('refreshToken');
    window.location.href = '/login';
    throw new Error('Token expirado o inválido');
  }

  return response;
};
